import { Box, Tooltip, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUser } from "@fortawesome/pro-solid-svg-icons"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { TranslationKey } from "../../../modules/localization/translations"

const useStyles = makeStyles()((theme) => ({
    badge: {
        display: "inline-flex",
        alignItems: "center",
        boxSizing: "border-box",
        gap: ".375rem",
        padding: ".25rem .75rem",
        borderRadius: "6.25rem",
        background: theme.palette.tailwind.amber[300],
        color: theme.palette.tailwind.slate[800],
    },
    icon: {
        fontSize: ".875rem",
        color: theme.palette.tailwind.slate[800],
    },
    value: {
        fontWeight: 700,
        color: theme.palette.tailwind.slate[800],
        whiteSpace: "nowrap",
    },
}))

type Props = Readonly<{
    count: number
    tooltipTitleId?: TranslationKey
    className?: string
}>

export function SeatsBadge({ count, tooltipTitleId, className }: Props) {
    const { classes, cx } = useStyles()

    const badge = (
        <Box className={cx(classes.badge, className)}>
            <FontAwesomeIcon icon={faUser} className={classes.icon} />
            <Typography variant="body2" component="span" className={classes.value}>
                {count}
            </Typography>
        </Box>
    )

    if (!tooltipTitleId) return badge

    return (
        <LocalizedStrict id={tooltipTitleId} attrs={{ title: true }}>
            <Tooltip arrow title="Seats">
                {badge}
            </Tooltip>
        </LocalizedStrict>
    )
}
